import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SpreadsheetArticle from "../pages/article/SpreadsheetArticle";
import QCPhotosArticle from "../pages/article/QCPhotosArticle";
import ShippingArticle from "../pages/article/ShippingArticle";
import SafetyArticle from "../pages/article/SafetyArticle";
import PillarArticle from "../pages/article/PillarArticle";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/allchinabuy-spreadsheet/",
    element: <SpreadsheetArticle />,
  },
  {
    path: "/how-to-read-qc-photos/",
    element: <QCPhotosArticle />,
  },
  {
    path: "/shipping-methods-compared/",
    element: <ShippingArticle />,
  },
  {
    path: "/is-allchinabuy-safe/",
    element: <SafetyArticle />,
  },
  {
    path: "/allchinabuy-review/",
    element: <PillarArticle slug="/allchinabuy-review/" />,
  },
  {
    path: "/allchinabuy-shipping-cost/",
    element: <PillarArticle slug="/allchinabuy-shipping-cost/" />,
  },
  {
    path: "/allchinabuy-warehouse/",
    element: <PillarArticle slug="/allchinabuy-warehouse/" />,
  },
  {
    path: "/allchinabuy-coupon/",
    element: <PillarArticle slug="/allchinabuy-coupon/" />,
  },
  {
    path: "/is-allchinabuy-legit/",
    element: <PillarArticle slug="/is-allchinabuy-legit/" />,
  },
  {
    path: "/allchinabuy-seller-guide/",
    element: <PillarArticle slug="/allchinabuy-seller-guide/" />,
  },
  {
    path: "/how-to-find-products/",
    element: <PillarArticle slug="/how-to-find-products/" />,
  },
  {
    path: "/allchinabuy-buying-guide/",
    element: <PillarArticle slug="/allchinabuy-buying-guide/" />,
  },
  {
    path: "/allchinabuy-shipping-calculator/",
    element: <PillarArticle slug="/allchinabuy-shipping-calculator/" />,
  },
  {
    path: "/common-allchinabuy-mistakes/",
    element: <PillarArticle slug="/common-allchinabuy-mistakes/" />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;